export function SectionCardHeader(props) {
    return (
        <div className="z-30 flex flex-col gap-0 mr-0 lg:mr-[36rem] xl:mr-[38rem]">
            <div
                className={`font-[700] my-0 w-full font-oswald leading-[1.2] text-[4.4rem] lg:text-[6rem] xl:text-[8rem] break-keep hyphens-auto ${
                    props.titleClassName ? props.titleClassName : ""
                }`}
            >
                {props.title}
            </div>
            {props.text && (
                <p className="text-lg my-0 pt-12 font-openSans font-regular">
                    {props.text}
                </p>
            )}
        </div>
    );
}
